import React from 'react';
import { useCallback } from 'react';
import { Image } from 'react-bootstrap';


const PdfGenerator = (({ data, company, type }) => {

    function calculateDiscount(originalPrice, discountPercentage, operation) {

        const discountAmount = (originalPrice * discountPercentage) / 100;
        let finalPrice = 0;

        if (operation == 'add') {
            finalPrice = originalPrice + discountAmount;
        } else {
            finalPrice = originalPrice - discountAmount;
        }
        return finalPrice;
    }

    function formatRupees(amount) {
        const formatter = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            currencyDisplay: 'code',
            maximumFractionDigits: 2
        });
        return formatter.format(amount);
    }

    const totalCalculate = useCallback((data) => {
        let total = calculateDiscount(data.products.reduce((sum, item) =>
            item.taxed ? sum + parseFloat(item.taxprice || 0) : sum + parseFloat(item.total || 0), 0)
            , data.products.reduce((sum, item) => sum + parseFloat(item.discount || 0), 0))

        let temp = calculateDiscount(total, ((data.tcsid || data.tdsid) ? data.tdsid ? data.tdsrate : data.tcsrate : 0), 'minus');

        return temp.toFixed(2);
    }, [data])

    return (
        <div>
            <div style={{ padding: '20px', backgroundColor: '#fff', margin: '20px', lineHeight: 1.5, fontFamily: 'Sans-serif' }}>
                <div style={{ margin: '20px 20px 40px 20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {company.logo && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Image src={company.logo} crossOrigin='anonymous' width={200} height={100} fluid rounded alt="Company Logo" />
                        </div>}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div>
                                {type === 'Sales Invoice' &&
                                    <div>
                                        <h2>Sales Invoice</h2>
                                        <div>Invoice Number : {data.invoiceno} </div>
                                        <div>Date Created : {new Date(data.createdat).toLocaleDateString('en-IN')}</div>
                                    </div>
                                }

                                {type === 'Purchase Invoice' &&
                                    <div>
                                        <h2>Purchase Invoice</h2>
                                        <div>Invoice Number : {data.purchaseno} </div>
                                        <div>Date Created : {new Date(data.createdat).toLocaleDateString('en-IN')}</div>
                                        <div></div>
                                    </div>
                                }

                                {type === 'Quotation' && 
                                <div>
                                    <h2>Quotation</h2>
                                    <div>Valid Till : {new Date(data.duedate).toLocaleDateString('en-IN')}</div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <hr />

                {
                    type === 'Purchase Invoice' ? <div style={{ margin: '20px 20px 40px 20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ maxWidth: 320 }}>
                                <div>To :</div>
                                <div style={{ fontWeight: 'bold' }}>{company.companyname}  </div>
                                <div>{company.address}  </div>
                                <div>{company.email} </div>
                                <div>{company.telephone} </div>
                                <div>{company.taxnumber}</div>
                            </div>
                            <div style={{ maxWidth: 300 }}>
                                <div>From :</div>

                                <div style={{ fontWeight: 'bold' }}>{`${data.salutation} ${data.firstname} ${data.lastname != null ? data.lastname : ''} , ${data.title}`} </div>
                                <div>{data.company} </div>
                                <div>{`${data.street} ${data.city} ${data.state}`} </div>
                                <div>{`${data.country}`} </div>
                                <div>{data.taxid && data.taxid} </div>
                            </div>
                        </div>
                    </div> :
                        <div style={{ margin: '20px 20px 40px 20px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ maxWidth: 320 }}>
                                    <div>To :</div>
                                    <div style={{ fontWeight: 'bold' }}>{`${data.salutation} ${data.firstname} ${data.lastname != null ? data.lastname : ''} , ${data.title}`} </div>
                                    <div>{data.company} </div>
                                    <div>{`${data.street} ${data.city} ${data.state}`} </div>
                                    <div>{`${data.country}`} </div>
                                    <div>{data.taxid && data.taxid} </div>
                                </div>
                                <div style={{ maxWidth: 300 }}>
                                    <div>From :</div>
                                    <div style={{ fontWeight: 'bold' }}>{company.companyname}  </div>
                                    <div>{company.address}  </div>
                                    <div>{company.email} </div>
                                    <div>{company.telephone} </div>
                                    <div>{company.taxnumber}</div>
                                </div>
                            </div>
                        </div>
                }


                <div style={{ margin: '20px 20px 40px 20px' }}>
                    {/* <div>
            <h3>Products : </h3>
        </div> */}
                    <table style={{ width: '100%', borderCollapse: 'collapse', margin: '20px 0', fontSize: '16px', textAlign: 'left' }}>
                        <thead>
                            <tr>
                                <th style={{ padding: '12px', borderBottom: '1px solid #ddd', background: '#f2f2f2', fontWeight: 'bold' }}>Product Name</th>
                                <th style={{ padding: '12px', borderBottom: '1px solid #ddd', background: '#f2f2f2', fontWeight: 'bold' }}>Qty</th>
                                <th style={{ padding: '12px', borderBottom: '1px solid #ddd', background: '#f2f2f2', fontWeight: 'bold' }}>Price</th>
                                <th style={{ padding: '12px', borderBottom: '1px solid #ddd', background: '#f2f2f2', fontWeight: 'bold' }}>Discount</th>
                                <th style={{ padding: '12px', borderBottom: '1px solid #ddd', background: '#f2f2f2', fontWeight: 'bold' }}>Total</th>
                                <th style={{ padding: '12px', borderBottom: '1px solid #ddd', background: '#f2f2f2', fontWeight: 'bold' }}>Tax Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.products.map((d, index) => (
                                <tr key={index}>
                                    <td style={{ padding: '12px', borderBottom: '1px solid #ddd', background: index % 2 == 0 ? '#f9f9f9' : '#fff' }}>{d.productname}</td>
                                    <td style={{ padding: '12px', borderBottom: '1px solid #ddd', background: index % 2 == 0 ? '#f9f9f9' : '#fff' }}>{d.quantity}</td>
                                    <td style={{ padding: '12px', borderBottom: '1px solid #ddd', background: index % 2 == 0 ? '#f9f9f9' : '#fff' }}>{d.price}</td>
                                    <td style={{ padding: '12px', borderBottom: '1px solid #ddd', background: index % 2 == 0 ? '#f9f9f9' : '#fff' }}>{d.discount}</td>
                                    <td style={{ padding: '12px', borderBottom: '1px solid #ddd', background: index % 2 == 0 ? '#f9f9f9' : '#fff' }}>{formatRupees(d.total)}</td>
                                    <td style={{ padding: '12px', borderBottom: '1px solid #ddd', background: index % 2 == 0 ? '#f9f9f9' : '#fff' }}>{formatRupees(d.taxprice)}</td>
                                </tr>
                            ))}
                            {(data.tdsid || data.tcsid) && <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }} colSpan="2"><b>{(data.tdsid || data.tcsid) ? (data.tcsid ? 'TCS -' : 'TDS -') : ''} {(data.tdsid || data.tcsid) ? (data.tcsid ? data.tcsrate + ' %' : data.tdsrate + ' %') : ''}</b></td>
                            </tr>}
                            {(data.taxtype && data.taxamount) && data.taxtype?.split(',').map((d,i) => (<tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style={{padding:'12px',borderBottom:'1px solid #ddd'}}>
                                            <div key={i}><b>{d}</b></div>
                                        </td>
                                        <td style={{padding:'12px',borderBottom:'1px solid #ddd'}}>{formatRupees(data.taxamount/data.taxtype?.split(',').length)}</td>
                            </tr>))}
                <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}><b>Grand Total</b> </td>
                                <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>{formatRupees(totalCalculate(data))} </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div style={{ margin: '20px 20px 40px 20px' }}>
                    <div>
                        Notes: In case of any query feel free to revert back.
                    </div>
                </div>

                <div style={{ margin: '20px 20px 40px 20px' }}>
                    {company.bankdetail && <><div>Bank Details:</div>
                        <div>{company.bankdetail}</div></>}
                </div>
            </div>
        </div>
    );
});

export default PdfGenerator;
